import { createWorkshopRegistration } from './createWorkshopRegistration.js';
import { createWorkshopRegistrationExternal } from './createWorkshopRegistrationExternal.js';
import { getWorkshopAttendanceByAccessToken } from './getWorkshopAttendanceByAccessToken.js';
import { mutationWorkshopMigration } from './mutationWorkshopMigration.js';
import { mutationWorkshopMigrationOnboarding } from './mutationWorkshopMigrationOnboarding.js';
import { sendWorkshopParticipationEmail } from './sendWorkshopParticipantsMail.js';
import { sendWorkshopRegistrationEmail } from './sendWorkshopRegistrationMail.js';
import { sendWorkshopStornoMail } from './sendWorkshopStornoMail.js';
import { stornoWorkshopAttendanceByAccessToken } from './stornoWorkshopAttendanceByAccessToken.js';
import { subscribeWorkshopAllAttendanceSimple } from './subscribeWorkshopAllAttendanceSimple.js';
import { subscribeWorkshopAttendance } from './subscribeWorkshopAttendance.js';
import { subscribeWorkshopAttendanceCount } from './subscribeWorkshopAttendanceCount.js';
import { subscribeWorkshopAttendanceSimple } from './subscribeWorkshopAttendanceSimple.js';
import { subscribeWorkshopOnboarding } from './subscribeWorkshopOnboarding.js';
import { subscribeWorkshopTrainingAttendance } from './subscribeWorkshopTrainingAttendance.js';
import { subscribeWorkshopTrainingAttendanceSimple } from './subscribeWorkshopTrainingAttendanceSimple.js';

export namespace WorkshopAPI {
  // Migrate
  export const migrate = mutationWorkshopMigration;
  export const migrateOnboarding = mutationWorkshopMigrationOnboarding;

  // Subscribe
  export const subscribeAllAttendanceSimple = subscribeWorkshopAllAttendanceSimple;
  export const subscribeAttendance = subscribeWorkshopAttendance;
  export const subscribeAttendanceCount = subscribeWorkshopAttendanceCount;
  export const subscribeAttendanceSimple = subscribeWorkshopAttendanceSimple;
  export const subscribeOnboarding = subscribeWorkshopOnboarding;
  export const subscribeTrainingAttendance = subscribeWorkshopTrainingAttendance;
  export const subscribeTrainingAttendanceSimple = subscribeWorkshopTrainingAttendanceSimple;

  // Mail
  export const sendRegistrationEmail = sendWorkshopRegistrationEmail;
  export const sendStornoEmail = sendWorkshopStornoMail;
  export const sendParticipationEmail = sendWorkshopParticipationEmail;

  // Registration
  export const createRegistration = createWorkshopRegistration;
  export const createRegistrationExternal = createWorkshopRegistrationExternal;

  // Other
  export const getAttendanceByAccessToken = getWorkshopAttendanceByAccessToken;
  export const stornoAttendanceByAccessToken = stornoWorkshopAttendanceByAccessToken;
}
